import React from 'react';

const TableMessages = ({
  message = 'Não existem registros para serem migrados'
}) => (
  <div className='table-messages'>
    <span>{message}</span>
  </div>
)

export default TableMessages;
